import { render, staticRenderFns } from "./home.vue?vue&type=template&id=f85c3da2&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=f85c3da2&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/custom.scss?vue&type=style&index=1&id=f85c3da2&prod&lang=scss&scoped=true&external"
import style2 from "./home.vue?vue&type=style&index=2&id=f85c3da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85c3da2",
  null
  
)

export default component.exports